import copy from "copy-to-clipboard";
import type { Directive } from "vue";
const isFunction = (e: any) => e instanceof Function;
export const vCopy: Directive = {
    mounted(el: HTMLElement, { value }) {
        el.classList.add("cursor-pointer");
        el.addEventListener("click", async () => {
            let result = "";
            if (isFunction(value)) {
                result = await value();
            } else {
                result = value;
            }
            copy(result, import.meta.env.PROD ? {} : { debug: true, message: "Press #{key} to copy" });
        });
    },
};
